import { FlexBox, ItemSelector } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';

interface ManageProductOptionsProps {
  options: {
    appointmentProposalOptionId: string;
    name: string;
    isReadOnly?: boolean;
  }[];
  selectedOptionIds: string[];
  isLoading: boolean;
  header?: React.ReactNode;
  setSelectedOptionIds: (ids: string[]) => void;
}

const ManageProductOptions: React.FC<ManageProductOptionsProps> = ({
  options,
  selectedOptionIds,
  isLoading,
  header,
  setSelectedOptionIds,
}) => {
  const handleOptionCheckboxChange = (optionId: string) => {
    if (selectedOptionIds.includes(optionId)) {
      setSelectedOptionIds(selectedOptionIds.filter((id) => id !== optionId));
    } else {
      setSelectedOptionIds([...selectedOptionIds, optionId]);
    }
  };

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      {header || <Typography variant="subtitle2">Add to Options</Typography>}
      <FlexBox gap={2} flexWrap="wrap">
        {options.map((option) => (
          <ItemSelector
            key={option.appointmentProposalOptionId}
            label={option.name}
            value={option.name}
            checked={selectedOptionIds.includes(
              option.appointmentProposalOptionId
            )}
            type="checkbox"
            disabled={isLoading || option.isReadOnly}
            handleChange={() =>
              handleOptionCheckboxChange(option.appointmentProposalOptionId)
            }
          />
        ))}
      </FlexBox>
    </FlexBox>
  );
};

export default ManageProductOptions;
